// eslint-disable-next-line no-unused-vars
import { FormGeneratorConfig } from '../../../utils/formGenerator'
import { FbSelectFormElement, FbTextFieldFormElement } from '../../../utils/formElements'
import { TenantGroupFormElement } from "../../Optimization/StorageLocationOptimization/StorageLocationOptimization";
import { hasRole } from "../../../services/developerAccessService";

export const UserSettingsFormConfig = (assignedRoles: string[]): FormGeneratorConfig => {
    let config = {
        name: {
            component: FbTextFieldFormElement,
            childProps: {
                label: 'Name',
                disabled: true,
            },
        },
        surname: {
            component: FbTextFieldFormElement,
            childProps: {
                label: 'Surname',
                disabled: true,
            },
        },
        email: {
            component: FbTextFieldFormElement,
            childProps: {
                label: 'E-Mail',
                disabled: true,
            },
        },
        department: {
            component: FbTextFieldFormElement,
            childProps: {
                label: 'Department',
                disabled: true,
            },
        }
    }

    if (hasRole(assignedRoles, "superAdmin")) {
        const tenant = {
            component: TenantGroupFormElement,
            childProps: {
                label: 'Tenant',
            }
        }
        config = Object.assign(config, {tenant})
        }

    return config
}
